import React from 'react';
import { meterText } from './usageRules';
import { hapticTick } from '../../_utils/haptics';
import './planUsage.css';

/**
 * Small shared pieces for the pricing screens.
 */

const UPGRADE_EVENT = 'beu:bailey-upgrade';

/**
 * Open the Beu + Bailey modal from anywhere (Plan & usage, Bailey's chat,
 * the receptionist screen, an alert). PricingHost listens at router level.
 *   mode: 'upgrade' | 'manage'
 *   from: where it was opened, for the record
 */
export function openUpgrade(opts = {}) {
    try { window.dispatchEvent(new CustomEvent(UPGRADE_EVENT, { detail: { mode: opts.mode || 'upgrade', from: opts.from || '' } })); } catch (e) { /* old browser */ }
}
export function onUpgradeRequest(fn) {
    const h = (e) => fn((e && e.detail) || {});
    window.addEventListener(UPGRADE_EVENT, h);
    return () => window.removeEventListener(UPGRADE_EVENT, h);
}

// Plan & billing is one page at the Billing URL; /settings/plan-usage redirects here.
export const PLAN_USAGE_PATH = '/settings/billing';

/**
 * A usage meter. The bar is decoration for sighted users; the numbers are
 * always written out, and the progressbar carries the same words.
 */
export function Meter({ label, m, unit, value, foot, resets, srText }) {
    if (!m) return null;
    const text = srText || meterText(m, unit);
    const warnText = m.level === 'full' ? 'All used' : m.level === 'warn' ? 'Nearly used' : '';
    return (
        <div className={`pu-meter is-${m.level}`}>
            <div className="pu-meter-top">
                <b>{label}</b>
                <span className="pu-meter-value">{value || (m.unlimited ? <strong>Unlimited</strong> : <><strong>{m.used.toLocaleString('en-GB')}</strong> of {m.allowance.toLocaleString('en-GB')}</>)}</span>
            </div>
            {!m.unlimited && (
                <div className="pu-bar" role="progressbar" aria-label={label} aria-valuemin={0} aria-valuemax={100} aria-valuenow={m.pct} aria-valuetext={text}>
                    <span style={{ width: `${m.pct}%` }} />
                </div>
            )}
            {(warnText || foot || resets) && (
                <div className="pu-meter-foot">
                    {warnText && <span className={`is-${m.level}`}>{warnText}</span>}
                    {foot && <span>{foot}</span>}
                    {resets && <span>{resets}</span>}
                </div>
            )}
        </div>
    );
}

export function Switch({ on, disabled, onChange, label }) {
    return (
        <button type="button" role="switch" aria-checked={!!on} aria-label={label} disabled={disabled}
            className={`pu-switch${on ? ' is-on' : ''}`} onClick={() => { hapticTick(); onChange(!on); }}>
            <span />
        </button>
    );
}

export const Tick = ({ size = 16 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12" /></svg>
);
export const Dash = ({ size = 16 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true"><line x1="6" y1="12" x2="18" y2="12" /></svg>
);
